import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { useAuth } from '../contexts/AuthContext';
import { LOAD_FAILURE_QUERY_OPTIONS } from '../lib/load-failure';

export interface DraftRow {
  id: string;
  template_id: string;
  template_name?: string | null;
  updated_at?: string | null;
  created_at?: string | null;
}

/**
 * The caller's own saved, unsubmitted custom-form submissions. One query for
 * "My drafts" on the Forms lists and the "My drafts" tile on field Safety, so
 * the tile and the list it opens cannot disagree about whether there are any.
 *
 * `mine=true` is what the API scopes on. `submitted_by` is sent beside it
 * because an API that predates `mine` ignores that key and would return the
 * company's drafts, which this user cannot open (the update route is
 * owner-only).
 */
export function useMyDrafts() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['safety-drafts', user?.id],
    queryFn: async () => {
      const res = await api.safety.submissions({ status: 'draft', mine: 'true', submitted_by: user!.id, per_page: 50 });
      const body = res.data?.data ?? res.data;
      return (body?.submissions ?? []) as DraftRow[];
    },
    enabled: !!user?.id,
    ...LOAD_FAILURE_QUERY_OPTIONS,
  });
}
